var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner",style:({backgroundImage:('url('+_vm.banner+')')}),attrs:{"id":"investor_banner1"}},[_c('span',[_vm._v(_vm._s(_vm.$t("indexnav.Investor Enquiries"))),_c('i',{style:({
          display: this.$store.state.nowlanguage === 'en' ? 'none' : '',
        })},[_vm._v("Investor Enquiries")])])]),_c('section',{staticClass:"ab-item1"},[_c('bread-crumb')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{attrs:{"id":"iframeContainer"}})])
}]

export { render, staticRenderFns }